import React from "react";
import { Form } from "react-bootstrap";
export default function TextInput(props) {
  return (
    <>
      <Form.Group className={`mb-0 ${props?.className}`}>
        {props?.label ? <Form.Label>{props.label}</Form.Label> : null}
        <Form.Control
          required
          type="text"
          defaultValue={props?.value}
          onChange={(e) => props?.onChange(e, props)}
          onBlur={(e) => (props.onBlur ? props?.onBlur(e, props) : () => {})}
          placeholder={props?.placeHolder}
          maxLength={props?.maxLength}
        />
      </Form.Group>
    </>
  );
}
